module.exports = __webpack_public_path__ + "img/green-4-mb.9a7d1a09.png";